import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useApi } from "../../shared/api";
import SocialMedia from "./SocialMedia";
import SkeletonUpdateDetails from "../../components/skeleton/SkeletonUpdateDetails";
import "./update_responsive.css"
import { changeTitleAndMetaTags } from "../../shared/meta/metaTags";

const UpdateDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const API = useApi();

  const [event, setEvent] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [imgLoading, setImgLoading] = useState(true);


  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const res = await API.API_V1.update.getEvent(slug as string);
        await changeTitleAndMetaTags(res.data.event.meta_title, {
          description: res.data.event.meta_description,
          keywords: res.data.event.meta_keyword,
          cronical_url: window.location.href,
        });
        if (res?.data?.success) {
          setEvent(res.data.event);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [slug]);


    if (loading) {
    return <SkeletonUpdateDetails />;
  }
  if (!event) return <p className="text-center py-5">Event not found</p>;

  const handleSellNow=()=>{
    navigate('/sell-used-appliances')
  }

  return (
    <>
      {/* Breadcrumb */}
      <div className="section_breadcrumb update_page_breadcrums">
        <div className="container">
          <ul className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/updates">Updates</a></li>
            <li className="breadcrumb-item active breadcrumb-title">
            {event.event_title}
            </li>

          </ul>
        </div>
      </div>

      {/* Update Details */}
      <section className="update_details_Page update_top_image">
        <div className="container">
          <span className="update_type">
            {event.event_category || "PRESS RELEASE"}
          </span>

          <p className="posting_date">
            {new Date(event.event_date).toDateString()}
          </p>

          <h1 className="update_page_heading">
            {event.event_title}
          </h1>

          {/* Social Icons (TOP) */}
          <SocialMedia/>

     

          <div className="detail_img mb-4" style={{ position: "relative" }}>
            {/* Banner Skeleton – same as SkeletonUpdateDetails */}
            {imgLoading && (
              <div className="placeholder-glow">
                <span
                  className="placeholder col-12 d-block rounded"
                  style={{ height: "320px" }}
                ></span>
              </div>
            )}

            {/* Actual Image */}
            <img
              src={event.event_img}
              alt={event.event_title}
              className="img-fluid w-100"
              onLoad={() => setImgLoading(false)}
              onError={() => setImgLoading(false)}
              style={{ display: imgLoading ? "none" : "block" }}
            />
          </div>



          {/* Content Section */}
          <div className="detaild_para">
            {event.content ? (
              <div
                dangerouslySetInnerHTML={{ __html: event.content }}
              />
            ) : (
              <p className="detail_info">
                No content available
              </p>
            )}
          </div>

          {/* Share Section */}
          <p className="share_updates">Share the update</p>
          <SocialMedia/>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="bottom_green text-center">
        <div className="container">
          <div className="section_heading">
            Sell Used Electronics the Smart Way in 3
            <br className="none_md" /> Easy Steps
          </div>

          <p className="easy_steps">
            Best Price | Doorstep Pickup | Instant Payment
          </p>

          <button type="button" className="btn btn-success" onClick={handleSellNow}>
            Sell Now
          </button>
        </div>
      </section>
    </>
  );
};

export default UpdateDetailPage;
